export default __webpack_public_path__ + "static/media/SIFA_NL_SEQ15.2b81176c.mp3";